export const Spacing = {
    None: "none",
    Small: "small",
    Medium: "medium",
    Large: "large",
} as const

export type SpacingEnum = (typeof Spacing)[keyof typeof Spacing]
